import { useTranslation } from "react-i18next";
import SubmitSection from "../../components/buttons/submitSection/SubmitSection";
import TitlePanel from "../../components/captionTitle/CaptionTitle";

const NotFound = () => {
  const { t } = useTranslation();
  return (
    <div className="not-found-wrapper d-flex flex-column h-100" id="not-found">
      <TitlePanel text={t("notFound.title")} />
      <div className="row spacer small" />
      <div className="flex-grow-1"></div>
      <div className="row spacer" />
      <div className="pt-4">
        <SubmitSection showApproveBtn={false} showCancelBtn={false} showBackBtn={true} />
      </div>
    </div>
  );
};

export default NotFound;
